<template>
  <div class="min-h-screen relative overflow-hidden flex">
    <!--
      Latar dibuat sendiri di public/salestial-background.svg — tema celestial
      (langit, bintang, orbit) sesuai brand Salestial, digabung motif grid +
      chart. SVG lokal: tidak ada permintaan ke CDN, dan tetap tajam di layar
      besar. Logonya dari materi Salestial di
      /opt/development/izi_salestial_demo/assets/img.

      Maskot Luna sengaja TIDAK dipakai di sini: di layar lebar gambarnya
      terpotong tepi panel kaca dan menutupi motif chart di latar.
    -->
    <div class="absolute inset-0 bg-cover bg-center" style="background-image: url('/salestial-background.svg')" />

    <!-- Kiri: branding -->
    <div class="relative z-10 flex-1 flex-col justify-end pb-14 pl-16 hidden lg:flex overflow-hidden">
      <div class="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-[#07102b]/70 via-[#07102b]/30 to-transparent pointer-events-none" />

      <div class="relative">
        <div class="flex items-center gap-4 mb-6">
          <img src="/salestial-logo-white.png" alt="Salestial" class="w-14 h-14 drop-shadow-lg" />
          <span class="text-white text-4xl font-bold tracking-tight drop-shadow">Salestial</span>
        </div>
        <h1 class="text-[3.4rem] leading-[1.05] font-extrabold text-white drop-shadow-lg mb-5">
          360 Insight,<br/>Satu Dashboard
        </h1>
        <p class="text-white/85 text-base max-w-md leading-relaxed drop-shadow">
          Perilaku belanja, segmen pelanggan, dan profil per orang —<br/>
          jadi bahan aksi untuk AI sales, bukan cuma laporan.
        </p>
      </div>
    </div>

    <!-- Kanan: panel kaca -->
    <div class="relative z-10 w-full lg:w-[420px] min-h-screen flex items-center justify-center px-10 py-16 bg-white/40 backdrop-blur-2xl border-l border-white/40 shadow-2xl shadow-black/25">
      <slot />
    </div>
    <ConfirmDialog />
  </div>
</template>
